import React from 'react';
import { mockData } from '../../utils/mock';

const AboutSection = () => {
  return (
    <section id="about" className="py-8 px-4 relative" data-testid="about-section">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-red-600/10 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-3xl md:text-4xl font-black mb-2">
            THE <span className="text-red-500">OUTLAW</span> STORY
          </h2>
        </div>

        <div className="bg-gray-900/50 border-2 border-red-500/30 backdrop-blur-sm p-6 rounded-lg">
          <div className="space-y-4 text-sm text-gray-300 leading-relaxed">
            <p className="text-base font-semibold text-white">
              {mockData.about.intro}
            </p>

            {mockData.about.paragraphs.map((para) => (
              <p key={para.slice(0, 32)}>{para}</p>
            ))}

            <div className="mt-6 pt-6 border-t border-red-500/30">
              <p className="text-red-400 font-bold text-base mb-2">
                Part journalism, part outlaw. 100% independent.
              </p>
              <p className="text-gray-400 text-sm">
                Based in {mockData.about.location} and built for the people who want the real story.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
